import { render } from "./GridVendasPeriodo.vue?vue&type=template&id=34f81564"
import script from "./GridVendasPeriodo.vue?vue&type=script&lang=js"
export * from "./GridVendasPeriodo.vue?vue&type=script&lang=js"

import "./GridVendasPeriodo.vue?vue&type=style&index=0&id=34f81564&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__